{
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.primary.no-pde": [
    {
      "type": 0,
      "value": "Try it free"
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.primary.pde": [
    {
      "type": 0,
      "value": "Try now"
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.secondary": [
    {
      "type": 0,
      "value": "No thanks"
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.body.has-payment": [
    {
      "type": 0,
      "value": "Billing starts after "
    },
    {
      "type": 1,
      "value": "trialEndDate"
    },
    {
      "type": 0,
      "value": ". We’ll remind you before your trial ends. Downgrade to Free or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "switch plans"
        }
      ],
      "type": 8,
      "value": "Link"
    },
    {
      "type": 0,
      "value": " anytime."
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.body.no-payment": [
    {
      "type": 0,
      "value": "After your trial you can stay on your plan or downgrade to a free plan. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Explore plans"
        }
      ],
      "type": 8,
      "value": "Link"
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.header": [
    {
      "type": 0,
      "value": "Welcome to your "
    },
    {
      "offset": 0,
      "options": {
        "=1": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "-day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "-day"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": " free trial "
    },
    {
      "options": {
        "other": {
          "value": [
          ]
        },
        "premium": {
          "value": [
            {
              "type": 0,
              "value": "of Premium"
            }
          ]
        },
        "standard": {
          "value": [
            {
              "type": 0,
              "value": "of Standard"
            }
          ]
        }
      },
      "type": 5,
      "value": "edition"
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature1": [
    {
      "type": 0,
      "value": "See user data and insights in one place"
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature2": [
    {
      "type": 0,
      "value": "Control who can view, edit, and comment"
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature3": [
    {
      "type": 0,
      "value": "Create unlimited whiteboards"
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature1": [
    {
      "type": 0,
      "value": "Share read-only pages with external stakeholders"
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature2": [
    {
      "type": 0,
      "value": "Automate repetitive tasks"
    }
  ],
  "growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature3": [
    {
      "type": 0,
      "value": "Control who can edit and comment"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.admin-key": [
    {
      "children": [
        {
          "type": 0,
          "value": "Admin key"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Access restricted content so you can fix bugs, fast"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.automation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Automation"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": 10x more rule runs per month"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.page-insights": [
    {
      "children": [
        {
          "type": 0,
          "value": "Page insights"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": See who viewed your page and when"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.page-permissions": [
    {
      "children": [
        {
          "type": 0,
          "value": "Page permissions"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Choose who can view, edit, and comment"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.rovo": [
    {
      "children": [
        {
          "type": 0,
          "value": "Rovo"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": AI-powered search, chat, and agents"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.space-permissions": [
    {
      "children": [
        {
          "type": 0,
          "value": "Space permissions"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Choose who can access entire folders"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.admin-features-title": [
    {
      "type": 0,
      "value": "You also get more admin features"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.description": [
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " has requested to try the 'Archive' feature on the Confluence Standard plan. This will make it easy to archive outdated content and keep things tidy."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try the 'Archive' feature on the Confluence Standard plan. This will make it easy to archive outdated content and keep things tidy."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Archive'"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.title": [
    {
      "type": 0,
      "value": "Help your team keep Confluence work tidy and up-to-date"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " wants to try 'Archive'"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " keep Confluence work tidy and up-to-date"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.description": [
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " has requested to try the 'Calendars' feature on the Confluence Premium plan. This will make it easy to plan deadlines and time off across teams."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try the 'Calendars' feature on the Confluence Premium plan. This will make it easy to plan deadlines and time off across teams."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Calendars'"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.title": [
    {
      "type": 0,
      "value": "Help your team balance downtime with deadlines"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " wants to try 'Calendars'"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " balance downtime with deadlines"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.description": [
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " has requested to try features on the Confluence Standard plan."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try features on the Confluence Standard plan."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try new features"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.title": [
    {
      "type": 0,
      "value": "Unlock more insights, clarity, and speed for your team"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " wants to try new features"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.title": [
    {
      "type": 0,
      "value": "Unlock more insights, clarity, and speed for "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.explore-all-features": [
    {
      "type": 0,
      "value": "Explore all features →"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.get-started-button": [
    {
      "type": 0,
      "value": "Get Started"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Confluence logo"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.description": [
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " has requested to try the 'Pages insights and analytics' feature on the Confluence Standard plan. This will make it easy to see user engagement and make more informed decisions"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try the 'Pages insights and analytics' feature on the Confluence Standard plan. This will make it easy to see user engagement and make more informed decisions"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Page insights'"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.title": [
    {
      "type": 0,
      "value": "Unlock data and insights for your team"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " wants to try 'Page insights'"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.title": [
    {
      "type": 0,
      "value": "Unlock data and insights for "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.description": [
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " has requested to try the 'Page permissions' feature on the Confluence Standard plan. This will makes it easy to decide who can edit, view, and comment on pages."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try the 'Page permissions' feature on the Confluence Standard plan. This will makes it easy to decide who can edit, view, and comment on pages."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try 'Page permissions'"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.title": [
    {
      "type": 0,
      "value": "Help your team share more and worry less"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " wants to try 'Page permissions'"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " share more and worry less"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.description": [
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " has requested to try Rovo (AI) on the Confluence Standard plan. This will make it easy to summarize pages, get writing help, and generate ideas, fast."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested to try Rovo (AI) on the Confluence Standard plan. This will make it easy to summarize pages, get writing help, and generate ideas, fast."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team wants to try Rovo (AI)"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.title": [
    {
      "type": 0,
      "value": "Unlock improved writing and more creativity for your team"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " wants to try Rovo (AI)"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.title": [
    {
      "type": 0,
      "value": "Unlock improved writing and more creativity for "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.upgrade-trial-edition-info": [
    {
      "type": 0,
      "value": "Grant access on a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "free"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "type": 1,
      "value": "trialLengthDays"
    },
    {
      "type": 0,
      "value": "-day trial."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Cancel anytime"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". We'll remind you 3 days before your trial ends."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.description": [
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " has requested access to more whiteboards on the Confluence Premium plan. This will unlock unlimited whiteboards."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.description": [
    {
      "type": 0,
      "value": "Someone on your team has requested access to more whiteboards on the Confluence Premium plan. This will unlock unlimited whiteboards."
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.subject": [
    {
      "type": 0,
      "value": "Approval required: Someone in your team needs more Confluence whiteboards"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.title": [
    {
      "type": 0,
      "value": "Help your team turn ideas into action"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " needs more Confluence whiteboards"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.title": [
    {
      "type": 0,
      "value": "Help "
    },
    {
      "type": 1,
      "value": "requesterFullName"
    },
    {
      "type": 0,
      "value": " turn ideas into action"
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved. "
    }
  ],
  "growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.alternative": [
    {
      "type": 0,
      "value": "Don’t want to upgrade?"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.delete-files": [
    {
      "type": 0,
      "value": "Delete files"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.description-with-trial": [
    {
      "type": 0,
      "value": "Your storage is full and your team can't add attachments to their work. Get "
    },
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 0,
              "value": "more space"
            }
          ]
        },
        "premium": {
          "value": [
            {
              "type": 0,
              "value": "unlimited space"
            }
          ]
        }
      },
      "type": 5,
      "value": "edition"
    },
    {
      "type": 0,
      "value": " by upgrading to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "editionName"
    },
    {
      "type": 0,
      "value": " now, free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "days"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.description-without-trial": [
    {
      "type": 0,
      "value": "Your storage is full and your team can't add attachments to their work. Get "
    },
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 0,
              "value": "more space"
            }
          ]
        },
        "premium": {
          "value": [
            {
              "type": 0,
              "value": "unlimited space"
            }
          ]
        }
      },
      "type": 5,
      "value": "edition"
    },
    {
      "type": 0,
      "value": " by upgrading to "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "editionName"
    },
    {
      "type": 0,
      "value": " now."
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.label": [
    {
      "type": 0,
      "value": "Storage"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.logo": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " logo"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.quote": [
    {
      "type": 0,
      "value": "“"
    },
    {
      "type": 1,
      "value": "message"
    },
    {
      "type": 0,
      "value": "”"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.remaining": [
    {
      "type": 1,
      "value": "remaining"
    },
    {
      "type": 0,
      "value": " GB left"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.request": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "’s request"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.subject": [
    {
      "type": 0,
      "value": "[Approval Required] "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " needs more storage - upgrade now"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.teammate": [
    {
      "type": 0,
      "value": "A teammate"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.title": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " needs more storage"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.unsubscribe": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.upgrade": [
    {
      "type": 0,
      "value": "Get more storage"
    }
  ],
  "growth-transmuters.edition-upgrade.email.storage.used": [
    {
      "type": 0,
      "value": "Using "
    },
    {
      "type": 1,
      "value": "used"
    },
    {
      "type": 0,
      "value": " GB of "
    },
    {
      "type": 1,
      "value": "limit"
    },
    {
      "type": 0,
      "value": " GB"
    }
  ],
  "growth-transmuters.edition-upgrade.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "growth-transmuters.edition-upgrade.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "growth-transmuters.edition-upgrade.message-template.microsoft-teams.hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "growth-transmuters.edition-upgrade.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "growth-transmuters.edition-upgrade.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "growth-transmuters.edition-upgrade.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "growth-transmuters.edition-upgrade.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "growth-transmuters.edition-upgrade.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "post-office.growth-transmuters.edition-upgrade-with-digest.sample-hello-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, *This is notification test from post office*"
    }
  ],
  "post-office.growth-transmuters.edition-upgrade.slack.admin-context": [
    {
      "type": 0,
      "value": "You received this message because you are an admin of "
    },
    {
      "type": 1,
      "value": "siteName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.growth-transmuters.edition-upgrade.slack.message": [
    {
      "type": 1,
      "value": "requesterName"
    },
    {
      "type": 0,
      "value": " asked you to upgrade "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " to *"
    },
    {
      "type": 1,
      "value": "requestedEdition"
    },
    {
      "type": 0,
      "value": "* on "
    },
    {
      "type": 1,
      "value": "siteLink"
    },
    {
      "type": 0,
      "value": ".\n\nThe upgrade applies to the whole site."
    }
  ],
  "post-office.growth-transmuters.edition-upgrade.slack.open-site-button": [
    {
      "type": 0,
      "value": "Open site"
    }
  ],
  "post-office.growth-transmuters.edition-upgrade.slack.product.confluence": [
    {
      "type": 0,
      "value": "Confluence"
    }
  ],
  "post-office.growth-transmuters.edition-upgrade.slack.product.jira": [
    {
      "type": 0,
      "value": "Jira"
    }
  ],
  "post-office.growth-transmuters.edition-upgrade.slack.product.jira-product-discovery": [
    {
      "type": 0,
      "value": "Jira Product Discovery"
    }
  ],
  "post-office.growth-transmuters.edition-upgrade.slack.product.jira-service-management": [
    {
      "type": 0,
      "value": "Jira Service Management"
    }
  ],
  "post-office.xflow-access-request-slack-notification.app-description.confluence": [
    {
      "type": 1,
      "value": "requestorMention"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "needs"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "need"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "requestorCount"
    },
    {
      "type": 0,
      "value": " your approval to try Confluence, a collaboration app that lets your team create, share, and organize work in pages and spaces."
    }
  ],
  "post-office.xflow-access-request-slack-notification.app-description.jira-product-discovery": [
    {
      "type": 1,
      "value": "requestorMention"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "needs"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "need"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "requestorCount"
    },
    {
      "type": 0,
      "value": " your approval to try Jira Product Discovery, a roadmap and prioritization app that links to your Jira projects."
    }
  ],
  "post-office.xflow-access-request-slack-notification.app-description.jira-service-management": [
    {
      "type": 1,
      "value": "requestorMention"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "needs"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "need"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "requestorCount"
    },
    {
      "type": 0,
      "value": " your approval to try Jira Service Management, an app that helps your team unify and resolve requests faster."
    }
  ],
  "post-office.xflow-access-request-slack-notification.app-description.loom": [
    {
      "type": 1,
      "value": "requestorMention"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "needs"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "need"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "requestorCount"
    },
    {
      "type": 0,
      "value": " your approval to try Loom, an app that lets your team record and embed videos to Jira work items."
    }
  ],
  "post-office.xflow-access-request-slack-notification.app-description.service-collection": [
    {
      "type": 1,
      "value": "requestorMention"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "needs"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "need"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "requestorCount"
    },
    {
      "type": 0,
      "value": " your approval to try Service Collection, a suite of apps designed to help your team unify and resolve requests faster."
    }
  ],
  "post-office.xflow-access-request-slack-notification.more-actions-placeholder": [
    {
      "type": 0,
      "value": "More actions..."
    }
  ],
  "post-office.xflow-access-request-slack-notification.mute-for-1-day": [
    {
      "type": 0,
      "value": "Snooze for 1 day"
    }
  ],
  "post-office.xflow-access-request-slack-notification.requestor-mention-fallback": [
    {
      "type": 0,
      "value": "Someone"
    }
  ],
  "post-office.xflow-access-request-slack-notification.review-request-button": [
    {
      "type": 0,
      "value": "Review request"
    }
  ],
  "post-office.xflow-access-request-slack-notification.turn-off-notifications": [
    {
      "type": 0,
      "value": "Turn off these notifications"
    }
  ]
}